import { RootState } from '@/redux-store';

export const selectCurrentCompany = (state: RootState) => state.reducer.currentCompany;

export const selectCurrentCompanyName = (state: RootState) => state.reducer.currentCompany.name;
